import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import SubMenuItem from '../molecules/SubMenuItem.js';

/**
 * Header class.
 */
export default class Header extends Base {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    name: 'Header',
    components: {
      SubMenuItem,
    },
    refs: ['mobileBtn'],
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.body = document.querySelector('body');
    // if (window.scrollY > 0) this.$el.classList.add('is-sticky');
  }

  /**
   * Open Menu
   * @returns {void}
   */
  onMobileBtnClick() {
    this.body.classList.toggle('menu-is-open');
  }

  /**
   * Detect when header is resized
   * @param  {number} width
   * @returns {void}
   */
  resized({ width }) {
    if (width >= 1024 && this.body.classList.contains('menu-is-open')) {
      this.onMobileBtnClick();
    }
  }

  // /**
  //  * Detect when header is sticky
  //  * @param  {object} options
  //  * @param  {number} options.y
  //  * @returns {void}
  //  */
  // scrolled({ y }) {
  //   if (y > 0) {
  //     this.$el.classList.add('is-sticky');
  //   } else {
  //     this.$el.classList.remove('is-sticky');
  //   }
  // }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 96;

    toggleClass(document.documentElement, 'is-on-top', isOnTop);
    toggleClass(document.documentElement, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.documentElement, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.documentElement, 'is-scrolling-up', direction.y === 'UP');
  }
}
